














































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator"
import Button from "@/app/ui/components/Button/index.vue"
import DropdownSelect from "@/app/ui/components/DropdownSelect/index.vue"
import TextInput from "@/app/ui/components/TextInput/index.vue"
import DateTimePicker from "@/app/ui/components/DateTimePicker/index.vue"
import MultiselectV2 from "@/app/ui/components/MultiselectV2/index.vue"
import LoadingOverlay from "@/app/ui/components/LoadingOverlay/index.vue"
import {
  EnumStatus,
  EnumStatusV2,
  IFormDetail,
  IFormDetailV2,
  IHistoryFields,
  IOptions,
  IOptionsV2,
} from "@/app/infrastructures/misc/Constants/manageCourierDedicated"
import NestedMultiSelect from "../../../components/NestedMultiSelect/index.vue"
import dedicatedController from "@/app/ui/controllers/ManageCourierDedicatedController"
import {
  DedicatedCourierItemV2,
  GeoAddress,
  ManageCourierDedicatedDetail,
  ManageCourierDedicatedDetailV2,
} from "@/domain/entities/ManageCourierDedicated"
import { Utils } from "@/app/infrastructures/misc"
import CheckBox from '@/app/ui/components/CheckBox/index.vue'

interface ILocation {
  name: string
  isChecked: boolean
  geoAddressId: string
  isParentNotHidden: boolean
  isDisabled(): boolean
  setIsChecked(state: boolean): void
  children: Array<ILocation>
}

@Component({
  components: {
    Button,
    DropdownSelect,
    TextInput,
    DateTimePicker,
    MultiselectV2,
    LoadingOverlay,
    NestedMultiSelect,
    CheckBox
  },
})
class DetailAreaDedicatedPage extends Vue {
  dedicatedController = dedicatedController
  courierList: Array<IOptions> = []
  locationData: Array<ILocation> = []

  isAllData = false

  courierParameters = {
    page: 1,
    perPage: 10,
    q: "",
    sortBy: "ASC",
    driverType: "KVP",
    courierStatus: "",
  }

  geoAddressParameters = {
    search: "",
  }

  form: IFormDetailV2 = {
    areaName: "-",
    location: [],
    dedicatedMp: [],
    dedicatedCa: [],
    dedicatedCorporate: [],
    dedicatedCorporateMobil: [],
    dedicatedCorporateMotor: [],
    offerMethod: "",
    status: "",
    createdAt: "-",
    updatedAt: "-",
    createdBy: "-",
    updatedBy: "-",
  }

  historyFields: Array<IHistoryFields> = [
    {
      name: "Dibuat Tanggal",
      formKey: "createdAt",
    },
    {
      name: "Terakhir Diubah",
      formKey: "updatedAt",
    },
    {
      name: "Dibuat Oleh",
      formKey: "createdBy",
    },
    {
      name: "Diubah Oleh",
      formKey: "updatedBy",
    },
  ]

  created(): void {
    this.fetchAreaDedicatedDetailV2()
  }

  get geoAddressParams(): Record<string, string> {
    return this.geoAddressParameters
  }

  private fetchAreaDedicatedDetailV2(): void {
    this.dedicatedController.getDetailV2({id: Number(this.$route.params.id), isShowDetail: this.isAllData})
  }

  private fetchGeoAddress(): void {
    this.dedicatedController.getGeoAddress(this.geoAddressParams)
  }

  private onEdit(id: string): void {
    this.$router.push(
      `/offer/manage-courier-dedicated/area-dedicated/edit/${id}`
    )
  }

  private locationMapper(
    data: GeoAddress,
    existingIds: Array<number>
  ): ILocation {
    return {
      name: data.name || "",
      isChecked: false,
      geoAddressId: data.geoAddressId ? String(data.geoAddressId) : "",
      isParentNotHidden: false,
      isDisabled(): boolean {
        if (
          data.areaId &&
          data.geoAddressId &&
          data.areaId !== 0 &&
          !existingIds.includes(Number(data.geoAddressId))
        ) {
          return true
        } else if (data.children && data.children.length !== 0) {
          let childDisabledCount = 0

          this.children.forEach(child => {
            if (child.isDisabled()) {
              childDisabledCount++
            }
          })

          if (childDisabledCount === this.children.length) {
            return true
          }
        }

        return false
      },
      setIsChecked(state: boolean): void {
        this.isChecked = state
      },
      children: data.children
        ? data.children.map(child => {
            return this.locationMapper(child, existingIds)
          })
        : [],
    }
  }

  private setLocationState(
    locData: Array<ILocation>,
    idList: Array<number>
  ): void {
    locData.forEach(location => {
      if (
        location.geoAddressId &&
        idList.includes(Number(location.geoAddressId))
      ) {
        location.setIsChecked(true)
      }

      if (location.children.length !== 0) {
        this.setLocationState(location.children, idList)
      }
    })
  }

  @Watch("dedicatedController.dataGeoAddressList")
  setGeoAddressData(data: Array<GeoAddress>): void {
    this.locationData = data.map(item => {
      return this.locationMapper(item, this.form.location)
    })

    this.setLocationState(this.locationData, this.form.location)
  }

  mapLabelAssignee(value: string): string {
    if (value === "COURIER") return "Kurir"
    return value
  }

  mapLabelOfferType(value: string): string {
    if (value === "AUTO ASSIGN") return "Auto-Assign"
    if (value === "OFFER") return "Offer"
    return value || "-"
  }

  mapLabel(item: DedicatedCourierItemV2): string {
    if (item.assignee === "POS") {
      return `[${item.posCode}] ${item.posName}`
    }
    const phone = this.isAllData ? item.phone : '********'
    return `[${item.id}] ${item.name} (${item.courierType}) ${phone}`
  }

  onToggleAllData(): void {
    this.isAllData = !this.isAllData
    this.fetchAreaDedicatedDetailV2()
  }

  @Watch("dedicatedController.dataManageCourierDedicatedDetailV2")
  setDedicatedDetailData(data: ManageCourierDedicatedDetailV2): void {
    let dedicatedMp: Array<IOptionsV2> = []
    let dedicatedCa: Array<IOptionsV2> = []
    let dedicatedCorporate: Array<IOptionsV2> = []
    let dedicatedCorporateMobil: Array<IOptionsV2> = []
    let dedicatedCorporateMotor: Array<IOptionsV2> = []

    if (data.dedicatedMp) {
      dedicatedMp = data.dedicatedMp.map(item => {
        return {
          label: this.mapLabel(item),
          value: item.id,
          assignee: this.mapLabelAssignee(item.assignee),
          specialHandling: false
        }
      })
    }

    if (data.dedicatedCa) {
      dedicatedCa = data.dedicatedCa.map(item => {
        return {
          label: this.mapLabel(item),
          value: item.id,
          assignee: this.mapLabelAssignee(item.assignee),
          specialHandling: false
        }
      })
    }

    if (data.dedicatedCorporate) {
      dedicatedCorporate = data.dedicatedCorporate.map(item => {
        return {
          label: this.mapLabel(item),
          value: item.id,
          assignee: this.mapLabelAssignee(item.assignee),
          specialHandling: false
        }
      })
    }

    if (data.dedicatedCorporateCar) {
      dedicatedCorporateMobil = data.dedicatedCorporateCar.map(item => {
        return {
          label: this.mapLabel(item),
          value: item.id,
          assignee: this.mapLabelAssignee(item.assignee),
          specialHandling: item.isSpecialHandling
        }
      })
    }

    if (data.dedicatedCorporateMotorcycle) {
      dedicatedCorporateMotor = data.dedicatedCorporateMotorcycle.map(item => {
        return {
          label: this.mapLabel(item),
          value: item.id,
          assignee: this.mapLabelAssignee(item.assignee),
          specialHandling: item.isSpecialHandling
        }
      })
    }

    const res: IFormDetailV2 = {
      areaName: data.areaName || "",
      location: data.geoAddressIds ? data.geoAddressIds : [],
      dedicatedMp: dedicatedMp,
      dedicatedCa: dedicatedCa,
      dedicatedCorporate: dedicatedCorporate,
      offerMethod: this.mapLabelOfferType(data.offerType),
      status: data.isActive ? EnumStatusV2.AKTIF : EnumStatusV2.NONAKTIF,
      createdAt: data.createdAt
        ? Utils.formatTimeZone(Utils.formatDateWithIDLocale(data.createdAt))
        : "-",
      updatedAt: data.updatedAt
        ? Utils.formatTimeZone(Utils.formatDateWithIDLocale(data.updatedAt))
        : "-",
      createdBy: data.createdBy || "-",
      updatedBy: data.updatedBy || "-",
      dedicatedCorporateMobil: dedicatedCorporateMobil,
      dedicatedCorporateMotor: dedicatedCorporateMotor
    }

    this.form = res

    this.fetchGeoAddress()
  }
}
export default DetailAreaDedicatedPage;
